/**
 * Centralny plik konfiguracji środowiska
 * Automatycznie wykrywa czy jesteśmy lokalnie czy na serwerze
 *
 * Wszystkie inne pliki powinny importować konfigurację stąd:
 * import { API_URL, API_BASE, isLocal, isProduction } from '../config/environment';
 */

// Wykryj środowisko na podstawie hostname
const hostname = window.location.hostname;

// Sprawdź czy jesteśmy lokalnie
export const isLocal = hostname === 'localhost' || hostname === '127.0.0.1';

// Sprawdź czy jesteśmy na serwerze produkcyjnym
export const isProduction = !isLocal;

// Konfiguracja portów
const LOCAL_BACKEND_PORT = 8000;
const LOCAL_FRONTEND_PORT = 3000;

// URL-e API
export const API_BASE = isLocal
  ? `http://localhost:${LOCAL_BACKEND_PORT}`  // Lokalnie - osobny port backend
  : '';  // Produkcja - ten sam serwer (względny URL)

export const API_URL = isLocal
  ? `http://localhost:${LOCAL_BACKEND_PORT}/api`  // Lokalnie
  : '/api';  // Produkcja

// Eksportuj konfigurację jako obiekt
const ENV = {
  isLocal,
  isProduction,
  API_BASE,
  API_URL,

  // Dodatkowe ustawienia
  LOCAL_BACKEND_PORT,
  LOCAL_FRONTEND_PORT,

};

// Debug info (tylko lokalnie)
if (isLocal) {
  console.log('🔧 Environment:', isLocal ? 'LOCAL' : 'PRODUCTION');
  console.log('🔗 API URL:', API_URL);
}

export default ENV;
